import React from "react"
import styled from "styled-components"
import media from "../styles/media"
import text from "styles/text"
import colors from "styles/colors"
import ContentWidth from "components/ContentWidth"

const ByTheNumbers = ({ content }) => {
  const allColumns = content.columns.map(stat => (
    <Column key={stat.description}>
      <Stat>
        {stat.number}
        {stat.indicator}
      </Stat>
      <Body dangerouslySetInnerHTML={{ __html: stat.description }} />
    </Column>
  ))

  return (
    <ContentWidth>
      <ColumnDiv>
        <Eyebrow>{content?.eyebrow}</Eyebrow>
        <Header>{content.headlineNumber}</Header>
        <BodyCopy>{content?.body}</BodyCopy>
        <Columns>{allColumns}</Columns>
      </ColumnDiv>
    </ContentWidth>
  )
}
const Eyebrow = styled.p`
  ${text.eyebrow}
`
const BodyCopy = styled.p`
  ${text.bodyMd};
  width: 63.333vw;
  text-align: center;

  ${media.fullWidth} {
    width: 912px;
  }
  ${media.tablet} {
    width: 80.469vw;
  }
  ${media.mobile} {
    width: 87.85vw;
  }
`
const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.667vw;
  align-items: center;

  ${media.fullWidth} {
    gap: 24px;
  }
  ${media.tablet} {
    gap: 2.344vw;
  }
  ${media.mobile} {
    gap: 5.607vw;
  }
`
const Header = styled.h2`
  ${text.h2};
  width: 79.444vw;
  text-align: center;
  ${media.fullWidth} {
    width: 1144px;
  }
  ${media.tablet} {
    width: 92.188vw;
  }

  ${media.mobile} {
    width: 87.85vw;
    ${text.h2};
  }
`
const Columns = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 2.778vw;

  ${media.fullWidth} {
    justify-content: center;
    gap: 40px;
  }

  ${media.tablet} {
    justify-content: space-around;
    gap: unset;
  }

  ${media.mobile} {
    flex-direction: column;
    justify-content: center;
    gap: unset;
  }
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto;
  gap: 1.667vw;
  width: 24.583vw;

  ${media.fullWidth} {
    width: 354px;
    gap: 24px;
  }

  ${media.tablet} {
    width: 29.297vw;
    gap: 2.344vw;
  }

  ${media.mobile} {
    width: 74.766vw;
    gap: 5.607vw;
  }
`
const Stat = styled.p`
  ${text.stat};
  color: ${colors.primaryOrange};
`
const Body = styled.p`
  ${text.bodyMd};
  text-align: center;
  margin-bottom: 0.972vw;

  ${media.fullWidth} {
    margin-bottom: 14px;
  }

  ${media.tablet} {
    margin-bottom: 1.367vw;
  }

  ${media.mobile} {
    ${text.bodyMd};
    margin-bottom: 3.271vw;
  }

  a {
    ${text.bodySmBold};

    ${media.mobile} {
      ${text.bodyMdBold};
    }
  }
`

export default ByTheNumbers
